<template>
  <div class="tab-list">
    <a-tabs
      v-model="activeKey"
      type="editable-card"
      :tabBarStyle="barStyle"
      @tabClick="jump"
      @edit="edit"
      hide-add
    >
      <div slot="tabBarExtraContent">
        <a-dropdown>
          <div class="tab-extra">
            <a-icon type="more" class="tab-extra-icon" />
          </div>
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="closeOther">
              关闭其他
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
      <a-tab-pane
        v-for="pane in panes"
        :key="pane.key"
        :closable="panes.length != 1"
      >
        <span slot="tab">
          {{ pane.title }}
          <a-icon class="tab-icon" type="reload" />
          <!-- <transition name="nameoftransition"> </transition> -->
        </span>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
export default {
  name: 'workArea',
  data() {
    return {
      activeKey: undefined,
      panes: [],
      newTabIndex: 0,
      barStyle: {
        paddingLeft: '16px',
      },
    }
  },
  created() {
    this.changeKey(this.$route)
  },
  methods: {
    closeOther() {
      // 删除除当前的其他
      let index
      this.panes.forEach((item, i) => {
        if (item.key == this.activeKey) {
          index = i
        }
      })

      this.panes = [this.panes[index]]
    },
    changeKey({ path, meta, params, query }) {
      let index = undefined
      let res = false
      this.panes.forEach((item, i) => {
        if (item.key == path) {
          index = i
          res = true
        }
      })
      let panes = {
        key: path,
        title: meta.title,
        content: meta.subTitle,
        params,
        query,
      }
      res ? this.panes.splice(index, 1, panes) : this.panes.push(panes)

      this.activeKey = path
    },
    edit(targetKey, action) {
      this[action](targetKey)
    },
    remove(targetKey) {
      // todo 路由退回 改变路由状态
      let activeKey = this.activeKey
      let lastIndex
      this.panes.forEach((pane, i) => {
        if (pane.key === targetKey) {
          lastIndex = i - 1
        }
      })
      // if ((lastIndex = activeKey)) {
      //   this.$router.push({ path: '/', replace: true })
      //   return false
      // }
      const panes = this.panes.filter((pane) => pane.key !== targetKey)
      if (panes.length && activeKey === targetKey) {
        if (lastIndex >= 0) {
          activeKey = panes[lastIndex].key
        } else {
          activeKey = panes[0].key
        }
      }
      this.panes = panes
      this.activeKey = activeKey
    },
    jump(path) {
      // 找到原来的元素 并且找到之前的query
      if (this.activeKey == path) {
        return false
      }
      let index
      this.panes.forEach((pane, i) => {
        if (pane.key === path) {
          index = i
        }
      })
      this.$router.push({
        path: this.panes[index]['key'],
        params: this.panes[index]['params'],
        query: this.panes[index]['query'],
      })
    },
  },
  watch: {
    $route: {
      handler(val) {
        this.changeKey(val)
      },
      // 深度观察监听
      deep: true,
    },
  },
}
</script>
<style scoped>
.tab-list {
  padding: 8px 0px 0px;
  background-color: white;
  margin-bottom: 10px;
}
.tab-extra {
  width: 40px;
  margin-right: 8px;
}
.tab-extra-icon {
  padding-right: 8px;
  font-size: 16px;
}
.tab-extra-icon:hover {
  color: #1890ff;
}
.tab-icon {
  color: rgba(0, 0, 0, 0.45);
}

.tab-icon:hover {
  color: #1890ff;
}
</style>
